import Raven from 'raven-js';
import { createRoot } from 'react-dom/client';

import { ENABLE_SENTRY, SENTRY_DSN } from 'commons/constants/env';

import App from './App';

import './assets/fonts';

if (SENTRY_DSN && ENABLE_SENTRY) {
  Raven.config(`${SENTRY_DSN}?verify_ssl=0`).install();
}

const container = document.getElementById('root');
//eslint-disable-next-line
const root = createRoot(container!);
root.render(<App />);
